// Image URLs are injected by theme.liquid into window.BECKER_IMGS
var rating = 0;

// ==== SUPABASE REVIEW CONFIG ====
// Paste your Project URL and anon public key between the quotes below.
var SUPABASE_URL = 'https://cmfyzipmgmzzrwcyfyql.supabase.co';
var SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNtZnl6aXBtZ216enJ3Y3lmeXFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODMzMDA3MjUsImV4cCI6MjA5ODg3NjcyNX0.Ld9NvueUHl7nDJAyzSCB8NjwAQINTPd78_xzquVSUa4';
// ================================

var cartQty = 0; // live cart item count, fetched from Shopify
var cartDollars = 0; // live cart dollar total, fetched from Shopify
var cartSizeQtys = [0,0,0]; // live cart quantities per bit size
var cartOtherDollars = 0; // live cart dollars from non-Quickbit items
var sizeNames = ['3/16"', '1/4"', '5/16"'];
var sizeLabels = ['3/16" Porcelain Quickbit', '1/4" Porcelain Quickbit', '5/16" Porcelain Quickbit'];
var sizeImages = window.BECKER_IMGS || ['','',''];
var prices = [
  [4.05,3.64,3.24,2.50],
  [4.35,3.91,3.48,2.80],
  [4.65,4.15,3.65,2.85]
];
var tierBreaks = [{min:1,max:49},{min:50,max:99},{min:100,max:199},{min:200,max:999999}];
var productHandles = ['3-16-porcelain-quickbit','1-4-porcelain-quickbit','5-16-porcelain-quickbit'];

function getTierIdx(total) {
  if (total <= 0) return 0;
  for (var i = 0; i < tierBreaks.length; i++) {
    if (total >= tierBreaks[i].min && total <= tierBreaks[i].max) return i;
  }
  return tierBreaks.length - 1;
}

function focusSize(idx) {
  var img = document.getElementById('spotlight-img');
  var hdr = document.getElementById('table-size-label');
  if (img) {
    img.style.opacity = '0';
    setTimeout(function() {
      img.src = sizeImages[idx];
      if (hdr) hdr.textContent = sizeLabels[idx];
      img.style.opacity = '1';
    }, 150);
  }
}

function change(idx, d) {
  var el = document.getElementById('q' + idx);
  el.value = Math.max(0, (parseInt(el.value) || 0) + d);
  focusSize(idx);
  update();
}

function update() {
  var qtys = [0,1,2].map(function(i){ return Math.max(0, parseInt(document.getElementById('q'+i).value)||0); });
  var selecting = qtys[0]+qtys[1]+qtys[2];
  var combinedTotal = selecting + cartQty; // cart already has + what they're adding now
  var ti = getTierIdx(combinedTotal > 0 ? combinedTotal : selecting);
  for (var s=0;s<3;s++) for (var t=0;t<4;t++) document.getElementById('tc-'+s+'-'+t).classList.toggle('act', t===ti);
  var summaryEl = document.getElementById('summary-items');
  var hasAny = false; var html = '';
  for (var s=0;s<3;s++) {
    if (qtys[s]>0) {
      hasAny=true;
      var line=prices[s][ti]*qtys[s];
      html+='<div class="summary-item"><span class="summary-item-name">'+sizeNames[s]+'</span><span class="summary-item-detail">$'+line.toFixed(2)+'</span><span class="summary-item-sub">'+qtys[s]+' x $'+prices[s][ti].toFixed(2)+'</span></div>';
    }
  }
  summaryEl.innerHTML = hasAny ? html : '<span class="summary-empty">Add pieces above to build your order.</span>';
  document.getElementById('total-bits') && (document.getElementById('total-bits').textContent = cartQty + selecting);
  // Live total: re-price ALL pieces (already in cart + selecting now) at the combined tier
  var grand = cartOtherDollars || 0;
  for (var gs=0; gs<3; gs++){ grand += prices[gs][ti] * ((cartSizeQtys[gs]||0) + qtys[gs]); }
  var rt = document.getElementById('running-total');
  if (rt) rt.textContent = '$' + grand.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  var note = document.getElementById('tier-note');
  if (note) {
    var displayTotal = combinedTotal > 0 ? combinedTotal : cartQty;
    var displayTi = getTierIdx(displayTotal > 0 ? displayTotal : 1);
    if (displayTotal === 0) { note.innerHTML = ''; }
    else if (displayTi < 3) {
      var need = tierBreaks[displayTi+1].min - displayTotal;
      note.innerHTML = 'Add <span>'+need+'</span> more piece'+(need!==1?'s':'')+' to unlock the next price break.';
    } else {
      note.innerHTML = "You're at our best price.";
    }
  }
}

function scrollToShop() {
  var el = document.getElementById('quickbit-buy');
  if (!el) return;
  var navH = document.querySelector('.nav') ? document.querySelector('.nav').offsetHeight : 80;
  var top = el.getBoundingClientRect().top + window.pageYOffset - navH;
  window.scrollTo({top: top, behavior: 'smooth'});
}


// Compute the correct TIERED dollar total for whatever is in the Shopify cart.
// Shopify's cart.total_price uses base product prices and ignores our quantity tiers,
// so we recompute here using the same tier logic as the order table.
function computeTieredCartDollars(cart) {
  var qtyBySize = [0,0,0];
  var otherDollars = 0;
  (cart.items || []).forEach(function(item){
    var idx = productHandles.indexOf(item.handle);
    if (idx > -1) {
      qtyBySize[idx] += item.quantity;
    } else {
      // Non-Quickbit item: trust Shopify's line price
      otherDollars += (item.line_price || 0) / 100;
    }
  });
  var bitCount = qtyBySize[0] + qtyBySize[1] + qtyBySize[2];
  var ti = getTierIdx(bitCount);
  var bitDollars = 0;
  for (var s = 0; s < 3; s++) {
    bitDollars += prices[s][ti] * qtyBySize[s];
  }
  cartSizeQtys = qtyBySize;      // remember per-size cart qtys for live re-tiering
  cartOtherDollars = otherDollars;
  return bitDollars + otherDollars;
}

function updateCartTotal() {
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart){
      cartQty = cart.item_count;
      cartDollars = computeTieredCartDollars(cart);
      var cc = document.getElementById('cart-count');
      if (cc) cc.textContent = cart.item_count;
      var tb = document.getElementById('total-bits');
      if (tb) tb.textContent = cart.item_count;
      if (document.getElementById('q0')) update(); // refresh tier highlights and running total
    })
    .catch(function(){});
}

function addToCartShopify() {
  var qtys = [0,1,2].map(function(i){ return Math.max(0, parseInt(document.getElementById('q'+i).value)||0); });
  var total = qtys[0]+qtys[1]+qtys[2];
  if (total===0) { showToast('Please add at least one piece.'); return; }
  var fetches = [];
  var parts = [];
  for (var s=0;s<3;s++) {
    if (qtys[s]>0) {
      (function(sIdx, qty) {
        parts.push(qty+' x '+sizeNames[sIdx]);
        fetches.push(
          fetch('/products/'+productHandles[sIdx]+'.js')
            .then(function(r){ return r.json(); })
            .then(function(p){ return {id: p.variants[0].id, quantity: qty}; })
        );
      })(s, qtys[s]);
    }
  }
  Promise.all(fetches)
    .then(function(items){
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({items: items})
      });
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      return fetch('/cart.js');
    })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      cartQty = cart.item_count;
      cartDollars = computeTieredCartDollars(cart);
      var cc = document.getElementById('cart-count');
      if (cc) cc.textContent = cart.item_count;
      var tb = document.getElementById('total-bits');
      if (tb) tb.textContent = cart.item_count;
      showToast('Added to cart: '+parts.join(', '));
      [0,1,2].forEach(function(i){
        document.getElementById('q'+i).value = 0;
      });
      update();
    })
    .catch(function(err){
      console.error('Cart error:', err);
      showToast('Error adding to cart. Check product handles in Shopify admin.');
    });
}

function addSampleToCart() {
  if (localStorage.getItem('becker_sample_claimed') === 'true') {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var hasSample = cart.items.some(function(item){
          return item.handle === 'porcelain-quickbit-sample-pack';
        });
        if (hasSample) {
          showToast('Sample packs are limited to one per customer — looks like you already grabbed yours!');
        } else {
          localStorage.removeItem('becker_sample_claimed');
          document.getElementById('sample-modal').style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(function(){
        document.getElementById('sample-modal').style.display = 'flex';
        document.body.style.overflow = 'hidden';
      });
    return;
  }
  document.getElementById('sample-modal').style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeSampleModal(e) {
  if (!e || e.target === document.getElementById('sample-modal')) {
    document.getElementById('sample-modal').style.display = 'none';
    document.body.style.overflow = '';
  }
}

var selectedVariant = '2x-316';

function selectVariant(el, variant) {
  selectedVariant = variant;
  document.querySelectorAll('.sample-variant').forEach(function(v){ v.classList.remove('act'); });
  el.classList.add('act');
}

var SAMPLE_TITLES = {'2x-316':'3/16" x 2','2x-14':'1/4" x 2','2x-516':'5/16" x 2','1x-316-1x-14':'3/16" + 1/4"','1x-316-1x-516':'3/16" + 5/16"','1x-14-1x-516':'1/4" + 5/16"'}; function sampleVariantId(p) { var want = SAMPLE_TITLES[selectedVariant]; for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].title === want) return p.variants[i].id; } throw new Error('sample variant not found'); } function checkoutSample() {
  var handle = 'porcelain-quickbit-sample-pack';
  fetch('/products/'+handle+'.js')
    .then(function(r){
      if (!r.ok) throw new Error('not found');
      return r.json();
    })
    .then(function(p){
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({items:[{id: sampleVariantId(p), quantity: 1}]})
      });
    })
    .then(function(r){
      if (!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function(){
      localStorage.setItem('becker_sample_claimed', 'true');
      window.location.href = '/checkout';
    })
    .catch(function(){
      window.location.href = '/products/porcelain-quickbit-sample-pack';
    });
}

function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); }, 3000);
}







// ==== EMAIL SUBSCRIBE -> GOOGLE SHEETS ====
// Paste your Google Apps Script Web App URL between the quotes below.
var SUBSCRIBE_URL = 'https://script.google.com/macros/s/AKfycbw80QluoVLLTbWtqyrWgxVR3PyatKAdNLlAR8-oSB0fdVgL1zk0oi4HqHDignyWullW4A/exec';

function subscribeEmail(e) {
  if (e) e.preventDefault();
  var email = document.getElementById('footer-email').value.trim();
  var first = (document.getElementById('sub-first') || {}).value || '';
  var company = (document.getElementById('sub-company') || {}).value || '';
  var msg = document.getElementById('sub-msg');
  if (!email || email.indexOf('@') === -1) {
    msg.textContent = 'Please enter a valid email.';
    msg.className = 'sub-msg error';
    return;
  }
  if (SUBSCRIBE_URL === 'YOUR_GOOGLE_SCRIPT_URL') {
    msg.textContent = 'Subscribe form not connected yet.';
    msg.className = 'sub-msg error';
    return;
  }
  msg.textContent = 'Subscribing...';
  msg.className = 'sub-msg';

  var params = new URLSearchParams();
  params.append('first', first.trim());
  params.append('company', company.trim());
  params.append('email', email);

  fetch(SUBSCRIBE_URL, { method: 'POST', mode: 'no-cors', body: params })
    .then(function(){
      // no-cors on Apps Script returns opaque; assume success if no throw
      msg.textContent = 'Thanks for subscribing!';
      msg.className = 'sub-msg success';
      document.getElementById('footer-email').value = '';
      if (document.getElementById('sub-first')) document.getElementById('sub-first').value = '';
      if (document.getElementById('sub-company')) document.getElementById('sub-company').value = '';
    })
    .catch(function(){
      msg.textContent = 'Something went wrong. Please try again.';
      msg.className = 'sub-msg error';
    });
}

window.addEventListener('DOMContentLoaded', function() {
  sizeImages = window.BECKER_IMGS || ['','',''];
  var img = document.getElementById('spotlight-img');
  if (img && sizeImages[0]) img.src = sizeImages[0];
  var hdr = document.getElementById('table-size-label');
  if (hdr) hdr.textContent = 'Porcelain Quickbit';
  if (document.getElementById('q0')) update();
  updateCartTotal();
  loadReviews();
});

// HAMBURGER MENU
function initHamburger() {
  var btn = document.getElementById('nav-hamburger');
  var menu = document.getElementById('nav-mobile-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', function() {
    btn.classList.toggle('open');
    menu.classList.toggle('open');
  });
  document.addEventListener('click', function(e) {
    if (!btn.contains(e.target) && !menu.contains(e.target)) {
      btn.classList.remove('open');
      menu.classList.remove('open');
    }
  });
}
document.addEventListener('DOMContentLoaded', initHamburger);


// ==== SUPABASE REVIEW SYSTEM ====
function supabaseHeaders() {
  return { 'Content-Type': 'application/json', 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY };
}

function setStar(v) {
  rating = v;
  var stars = document.querySelectorAll('.rf-star');
  for (var i = 0; i < stars.length; i++) { stars[i].classList.toggle('act', i < v); }
}

function loadReviews() {
  var list = document.getElementById('rv-list');
  if (!list) return;
  if (SUPABASE_URL === 'YOUR_SUPABASE_URL') { renderReviews([]); return; }
  fetch(SUPABASE_URL + '/rest/v1/reviews?approved=eq.true&order=created_at.desc&select=*', { headers: supabaseHeaders() })
    .then(function(r){ return r.json(); })
    .then(function(data){ renderReviews(Array.isArray(data) ? data : []); })
    .catch(function(){ renderReviews([]); });
}

function submitReview() {
  var name  = (document.getElementById('rf-first').value || '').trim();
  var body  = (document.getElementById('rf-body').value || '').trim();
  var err   = document.getElementById('rf-error');
  if (!name)  { err.textContent = 'Please enter your name.'; return; }
  if (!rating){ err.textContent = 'Please select a star rating.'; return; }
  if (body.length < 10) { err.textContent = 'Please write at least 10 characters.'; return; }
  err.textContent = '';
  if (SUPABASE_URL === 'YOUR_SUPABASE_URL') { showToast('Reviews backend not configured yet.'); return; }

  var btn = document.querySelector('.rf-submit');
  if (btn) { btn.disabled = true; btn.textContent = 'Submitting...'; }
  var d = new Date();
  var dateStr = d.toLocaleDateString('en-US', {year:'numeric', month:'long', day:'numeric'});

  fetch(SUPABASE_URL + '/rest/v1/reviews', {
    method: 'POST',
    headers: supabaseHeaders(),
    body: JSON.stringify({ name: name, rating: rating, title: '', body: body, date: dateStr, approved: false })
  })
  .then(function(r){
    if (!r.ok) throw new Error('submit failed');
    var formBody = document.querySelector('.rf-body');
    if (formBody) {
      formBody.innerHTML = '<div class="rf-success">' +
        '<div class="rf-success-check">&#10003;</div>' +
        '<div class="rf-success-title">Your review has been submitted!</div>' +
        '<div class="rf-success-msg">Thank you for sharing your experience. Your review will appear on the site shortly.</div>' +
        '</div>';
    } else {
      showToast('Your review has been submitted!');
    }
  })
  .catch(function(){
    if (btn) { btn.disabled = false; btn.textContent = 'Submit Review'; }
    err.textContent = 'Error submitting review. Please try again.';
  });
}

var RV_PER_PAGE = 6;
var RV_ALL = [];
var RV_PAGE = 1;

function parseReviewDate(str) {
  var t = Date.parse(str);
  return isNaN(t) ? 0 : t;
}

function renderReviews(reviews) {
  var list = document.getElementById('rv-list');
  if (!list) return;
  if (!reviews.length) {
    list.innerHTML = '<div class="rv-empty">Be the first to leave a review!</div>';
    var pag = document.getElementById('rv-pagination');
    if (pag) pag.innerHTML = '';
    return;
  }

  // Sort newest-first by the actual review date
  reviews.sort(function(a, b){ return parseReviewDate(b.date) - parseReviewDate(a.date); });
  RV_ALL = reviews;

  // Summary stats (across ALL reviews, not just current page)
  var total = 0; var counts = {1:0,2:0,3:0,4:0,5:0};
  for (var i=0;i<reviews.length;i++){ total += reviews[i].rating; counts[reviews[i].rating]++; }
  var avg = (total/reviews.length).toFixed(1);
  var avgEl = document.getElementById('rs-avg'); if (avgEl) avgEl.textContent = avg;
  var cntEl = document.getElementById('rs-count'); if (cntEl) cntEl.textContent = reviews.length + ' review' + (reviews.length!==1?'s':'');
  var filled = Math.round(parseFloat(avg));
  var starsStr = '';
  for (var i=0;i<filled;i++) starsStr += '\u2605';
  for (var i=filled;i<5;i++) starsStr += '\u2606';
  var starsEl = document.getElementById('rs-stars'); if (starsEl) starsEl.textContent = starsStr;
  for (var s=1;s<=5;s++){
    var bar = document.getElementById('bar'+s); if (bar) bar.style.width = (Math.round(counts[s]/reviews.length*100)) + '%';
    var c = document.getElementById('cnt'+s); if (c) c.textContent = counts[s];
  }

  RV_PAGE = 1;
  renderReviewPage();
}

function renderReviewPage() {
  var list = document.getElementById('rv-list');
  if (!list) return;
  var totalPages = Math.max(1, Math.ceil(RV_ALL.length / RV_PER_PAGE));
  if (RV_PAGE > totalPages) RV_PAGE = totalPages;
  var start = (RV_PAGE - 1) * RV_PER_PAGE;
  var pageItems = RV_ALL.slice(start, start + RV_PER_PAGE);

  var safe = function(x){ var d=document.createElement('div'); d.textContent=x||''; return d.innerHTML; };
  list.innerHTML = '';
  pageItems.forEach(function(r){
    var st=''; for(var i=0;i<r.rating;i++) st+='\u2605'; for(var i=r.rating;i<5;i++) st+='\u2606';
    var card=document.createElement('div'); card.className='rv-card';
    card.innerHTML='<div class="rv-card-body">'+safe(r.body)+'</div>'+
      '<div class="rv-card-footer"><div class="rv-name">'+safe(r.name)+'</div><div class="rv-stars">'+st+'</div></div>';
    list.appendChild(card);
  });

  renderPagination(totalPages);
}

function renderPagination(totalPages) {
  var pag = document.getElementById('rv-pagination');
  if (!pag) {
    // create the container if it doesn't exist yet
    var list = document.getElementById('rv-list');
    pag = document.createElement('div');
    pag.id = 'rv-pagination';
    pag.className = 'rv-pagination';
    list.parentNode.insertBefore(pag, list.nextSibling);
  }
  if (totalPages <= 1) { pag.innerHTML = ''; return; }

  var html = '';
  // Prev arrow
  html += '<button class="rv-page-btn rv-page-arrow" ' + (RV_PAGE===1?'disabled':'') + ' onclick="gotoReviewPage(' + (RV_PAGE-1) + ')">&#8249;</button>';
  for (var p = 1; p <= totalPages; p++) {
    html += '<button class="rv-page-btn' + (p===RV_PAGE?' act':'') + '" onclick="gotoReviewPage(' + p + ')">' + p + '</button>';
  }
  // Next arrow
  html += '<button class="rv-page-btn rv-page-arrow" ' + (RV_PAGE===totalPages?'disabled':'') + ' onclick="gotoReviewPage(' + (RV_PAGE+1) + ')">&#8250;</button>';
  pag.innerHTML = html;
}

function gotoReviewPage(p) {
  var totalPages = Math.max(1, Math.ceil(RV_ALL.length / RV_PER_PAGE));
  if (p < 1 || p > totalPages) return;
  RV_PAGE = p;
  renderReviewPage();
  // scroll to top of review list
  var list = document.getElementById('rv-list');
  if (list) {
    var navH = document.querySelector('.nav') ? document.querySelector('.nav').offsetHeight : 80;
    var top = list.getBoundingClientRect().top + window.pageYOffset - navH - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
}

/* ---- Hero video lightbox ---- */
function openHeroVideo(){
  var lb=document.getElementById('hero-video-lb');
  if(lb) lb.classList.add('open');
  document.body.style.overflow='hidden';
  var v=document.getElementById('hvlb-video');
  if(v){ try{ v.currentTime=0; var p=v.play(); if(p&&p.catch){p.catch(function(){});} }catch(e){} }
}
function closeHeroVideo(e){
  if(e){var t=e.target; if(t.closest && t.closest('.hvlb-inner') && !t.classList.contains('hvlb-close')) return;}
  var lb=document.getElementById('hero-video-lb');
  if(lb) lb.classList.remove('open');
  var v=document.getElementById('hvlb-video'); if(v){ try{ v.pause(); }catch(e){} }
  document.body.style.overflow='';
}
